import { combineReducers } from "redux";

import { calendarEvents } from './calendarEvent';

export default combineReducers({
  calendarEvents
});